import { useRestoreScrollOnBack } from "@shared/hooks";
import { Route, Routes } from "@shared/react-router-dom";
import { wildcardPath } from "@shared/utils";
import { authRoutes } from "@unauthenticated/shared/data/authRoutes";
import type { PractitionerType } from "@unauthenticated/shared/data/types";
import { ContinueWithoutPasswordPage } from "@unauthenticated/signupSignin/scenes/ContinueWithoutPasswordPage";
import { LazyEditPasswordPage } from "@unauthenticated/signupSignin/scenes/EditPasswordPage";
import { EmersonSignInPage } from "@unauthenticated/signupSignin/scenes/EmersonSignInPage";
import { EmersonSignUpPage } from "@unauthenticated/signupSignin/scenes/EmersonSignUpPage";
import { LazyForgotPasswordPage } from "@unauthenticated/signupSignin/scenes/ForgotPasswordPage";
import { PatientSignUpPage } from "@unauthenticated/signupSignin/scenes/PatientSignUpPage";
import { PractitionerSignUpPage } from "@unauthenticated/signupSignin/scenes/PractitionerSignUpPage";
import { LazySignInPage } from "@unauthenticated/signupSignin/scenes/SignInPage";

interface Props {
  practitionerTypes: PractitionerType[];
  signUpAdditionalAttributes?: any;
  signInAdditionalAttributes?: any;
  csuid: string;
  ssoErrors?: string;
  authErrors?: string;
  pageVersion: "prac_by_default_with_sso" | "prac_by_default";
}

const Pages = ({
  practitionerTypes,
  signUpAdditionalAttributes,
  signInAdditionalAttributes,
  csuid,
  ssoErrors,
  authErrors,
  pageVersion,
}: Props) => {
  useRestoreScrollOnBack();

  return (
    <Routes>
      <Route path={wildcardPath(authRoutes.edit_password)} element={<LazyEditPasswordPage />} />
      <Route path={wildcardPath(authRoutes.forgot_password)} element={<LazyForgotPasswordPage />} />
      <Route
        path={wildcardPath(authRoutes.login)}
        element={
          <LazySignInPage
            ssoErrors={ssoErrors}
            authErrors={authErrors}
            additionalAttributes={signInAdditionalAttributes}
          />
        }
      />
      <Route
        path={wildcardPath(authRoutes.continue_without_password)}
        element={<ContinueWithoutPasswordPage />}
      />
      <Route
        path={wildcardPath(authRoutes.patient_sign_up)}
        element={<PatientSignUpPage csuid={csuid} pageVersion={pageVersion} />}
      />
      <Route
        path={wildcardPath(authRoutes.practitioner_sign_up)}
        element={
          <PractitionerSignUpPage
            practitionerTypes={practitionerTypes}
            additionalAttributes={signUpAdditionalAttributes}
            csuid={csuid}
            pageVersion={pageVersion}
            ssoErrors={ssoErrors}
          />
        }
      />
      <Route
        path={wildcardPath(authRoutes.wellevate_practitioner_sign_up)}
        element={
          <PractitionerSignUpPage
            practitionerTypes={practitionerTypes}
            additionalAttributes={signUpAdditionalAttributes}
            csuid={csuid}
            pageVersion={pageVersion}
            ssoErrors={ssoErrors}
          />
        }
      />
      <Route
        path={wildcardPath(authRoutes.emerson_ecologics_practitioner_sign_up)}
        element={
          <PractitionerSignUpPage
            practitionerTypes={practitionerTypes}
            additionalAttributes={signUpAdditionalAttributes}
            csuid={csuid}
            pageVersion={pageVersion}
            ssoErrors={ssoErrors}
          />
        }
      />
      <Route
        path={wildcardPath(authRoutes.emerson_sign_up)}
        element={
          <EmersonSignUpPage additionalAttributes={signUpAdditionalAttributes} csuid={csuid} />
        }
      />
      <Route
        path={wildcardPath(authRoutes.emerson_login)}
        element={<EmersonSignInPage additionalAttributes={signInAdditionalAttributes} />}
      />
      <Route
        path={wildcardPath(authRoutes.forgot_emerson_password)}
        element={<LazyForgotPasswordPage />}
      />
      <Route
        path={wildcardPath(authRoutes.edit_emerson_password)}
        element={<LazyEditPasswordPage />}
      />
    </Routes>
  );
};

export { Pages };
